import { AuthData, AuthService } from 'src/app/auth/auth.service';
import { HttpCacheService } from './http-cache.service';
import {Injectable} from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { map, catchError, switchMap, take } from 'rxjs/operators';
import { AlertController, ToastController } from '@ionic/angular';
import { Preferences } from '@capacitor/preferences';
import { Network } from '@capacitor/network';
import { Capacitor } from '@capacitor/core';

const TOKEN_KEY = 'token';
@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  user: AuthData;
  networkType = '';
  constructor(
    private alertController: AlertController,
    private httpCacheService: HttpCacheService,
    private toastController: ToastController,
    private authService: AuthService,
    ) {
      }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      Network.getStatus().then((connection) => {
        this.networkType = connection.connectionType;
      });
      return from(Preferences.get({key: TOKEN_KEY}))
        .pipe(
          switchMap(token => {
            if (token) {
              request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token.value) });
            }
            if (!request.headers.has('Content-Type')) {
              request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
            }
            request = request.clone({
              headers: request.headers.set('Accept', 'application/json')
            });
            if (Capacitor.getPlatform() === 'web') {
              return next.handle(request);
            }
            //only handle next if wifi connection
            if (this.networkType === 'wifi') {
              return this.wifiIntercept(request, next);
            }
            else {
              // cache data if not wifi
              if (request.url.indexOf('authenticate') === -1 && (request.method === 'PUT' || request.method === 'POST')) {
                const result = this.httpCacheService.setStorageRequest(request);
              }
              if (request.url.indexOf('authenticate') !== -1 && (request.method === 'PUT' || request.method === 'POST')) {
                console.log('HTTPINTERCEPT- authing over cellular connection');
                return this.wifiIntercept(request, next);
              }
              if (request.method === 'GET') {
                return this.wifiIntercept(request, next);
              }
            }
          })
        );
      }

  wifiIntercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
        }
        return event;
      }),
        catchError((error: HttpErrorResponse) => {
          console.log('HTTP ERROR', JSON.stringify(error));
          const status =  error.status;
          const message = error.message;
          const reason = error && error.error.reason ? error.error.reason : '';
          try {
            this.authService.getUserData().then((user) => {
              console.log('http interceptor user', user);
              if(JSON.parse(user.value).role === 'patient'){
                if (request.url.indexOf('authenticate') === -1
                && (request.method === 'PUT' || request.method === 'POST')) {
                  const result = this.httpCacheService.setStorageRequest(request);
                }
              }
            });
          } catch (error) {
            console.log('http interceptor error', error);
          }
          return throwError(error);
        })
      );
  }

  async presentToast(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 2000
    });
    toast.present();
  }

  async presentAlert(status, message) {
    const header = 'Network Error';
    const subHeader = 'could not communicate with network';
    if(status === 0){
      message = 'no internet connection, using offline mode';
    }

    const alert = await this.alertController.create({
      header,
      subHeader,
      message,
      buttons: ['OK']
    });

    await alert.present();
  }
}
